import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Check, Loader2 } from "lucide-react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function Plans({ user }) {
  const [plans, setPlans] = useState([]);
  const [mode, setMode] = useState(null);
  const [loading, setLoading] = useState(null);

  useEffect(() => { api.get("/plans").then(({ data }) => { setPlans(data.plans); setMode(data.mode); }).catch(() => {}); }, []);

  const subscribe = async (lookup_key) => {
    setLoading(lookup_key);
    try {
      const { data } = await api.post("/payments/checkout", { lookup_key, origin_url: window.location.origin });
      window.location.href = data.checkout_url;
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
      setLoading(null);
    }
  };

  return (
    <div className="space-y-6 animate-float-up">
      {mode && (
        <div className={`flex items-center gap-3 rounded-xl border p-4 ${mode === "live" ? "border-emerald-500/30 bg-emerald-500/5" : "border-amber-500/30 bg-amber-500/5"}`} data-testid="stripe-mode-banner">
          <span className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs font-mono font-semibold ${mode === "live" ? "border-emerald-500/40 text-emerald-500" : "border-amber-500/40 text-amber-500"}`}>
            <span className={`h-2 w-2 rounded-full ${mode === "live" ? "bg-emerald-500 pulse-ring" : "bg-amber-500"}`} />
            {mode === "live" ? "PAGAMENTOS AO VIVO" : "MODO DE TESTE"}
          </span>
          <p className="text-sm text-muted-foreground">
            {mode === "live"
              ? "Pagamentos reais estão ativos — cobranças serão processadas de verdade."
              : "Nenhuma cobrança real é feita. Reivindique sua conta Stripe (Republish → Manage → Payments) para ir ao vivo."}
          </p>
        </div>
      )}
      <p className="text-sm text-muted-foreground">Seu plano atual: <span className="font-semibold text-foreground">{user?.plan}</span>. Faça upgrade a qualquer momento. Pagamento seguro via Stripe{mode === "test" ? " (cartão de teste: 4242 4242 4242 4242)" : ""}.</p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {plans.map((p) => {
          const current = user?.plan === p.name;
          return (
            <div key={p.lookup_key} className={`rounded-xl border p-6 flex flex-col ${p.name === "PRO" ? "border-primary ring-1 ring-primary/40" : "border-border"} bg-card`}>
              {p.name === "PRO" && <span className="text-xs font-mono uppercase tracking-widest text-primary mb-2">Mais popular</span>}
              <h3 className="font-heading font-bold text-xl">{p.name}</h3>
              <p className="font-heading text-3xl font-bold mt-2">${p.price}<span className="text-sm text-muted-foreground font-normal">/mês</span></p>
              <ul className="mt-5 space-y-2 flex-1">
                {p.features.map((f) => (
                  <li key={f} className="flex items-start gap-2 text-sm text-muted-foreground"><Check className="h-4 w-4 text-primary mt-0.5 shrink-0" /> {f}</li>
                ))}
              </ul>
              {p.price === 0 ? (
                <Button variant="outline" className="mt-6 w-full" disabled data-testid={`sub-${p.lookup_key}`}>{current ? "Plano atual" : "Grátis"}</Button>
              ) : current ? (
                <Button variant="outline" className="mt-6 w-full" disabled>Plano atual</Button>
              ) : (
                <Button className="mt-6 w-full" variant={p.name === "PRO" ? "default" : "outline"} onClick={() => subscribe(p.lookup_key)} disabled={loading === p.lookup_key} data-testid={`sub-${p.lookup_key}`}>
                  {loading === p.lookup_key ? <Loader2 className="h-4 w-4 animate-spin" /> : "Assinar"}
                </Button>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
